module.exports = __webpack_public_path__ + "media/about_employee/vermont_2-b587a80a.png";